import Vue from "vue";
import CommaInput from "@/components/CommaInput.vue";
import HyphenInput from "@/components/HyphenInput.vue";

Vue.component("CommaInput", CommaInput);
Vue.component("HyphenInput", HyphenInput);
